import React, { useEffect, useState } from "react";
import {
  district,
  block,
  nWiseregionType,
  nWiseregionCode,
  selectedDYear,
  allSWiseregionType,
  allSWiseregionCode,
  specificSWiseregionType,
  allDWiseregionType,
  specificDWiseregionType,
  allBWiseregionType,
  specificBWiseregionType,
  nationalWiseName,
  stateWiseName,
  districtWiseName,
  blockWiseName,
  initialFilterEnrolmet4014Data,
} from "../../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStateData,
  updateFilterState,
} from "../../../redux/thunks/stateThunk";
import {
  fetchDistrictDataByStateCode,
  removeAllDistrict,
  updateFilterDistrict,
} from "../../../redux/thunks/districtThunk";
import { fetchYearData } from "../../../redux/thunks/yearThunk";
import { allFilter } from "../../../redux/slice/schoolFilterSlice";
import {
  updateUdiseBlockCode,
  updateUdiseDistrictCode,
} from "../../../redux/slice/DistBlockWiseSlice";
import {
  fetchBlockByDistrictCode,
  removeAllBlock,
  updateFilterBlock,
} from "../../../redux/thunks/blockThunk";
import { Select } from "antd";
import { useLocation, useParams } from "react-router-dom";

import {
  fetchArchiveServicesEnrolmentRelatedIndicators,
} from "../../../redux/thunks/archiveServicesThunk";
import {
  handleCurrentIndex,
  handleRegionName,
  handleShowDistrict,
  handleShowFilter,
  setSelectYearId,
} from "../../../redux/slice/headerSlice";
import { setSelectedStateCode } from "../../../redux/slice/stateSlice";

export default function FilterDropdown4014() {
  const dispatch = useDispatch();
  const location = useLocation();
  const acData = localStorage.getItem("acData");
  const parsedACData = JSON.parse(acData);
  const acDataForReset = localStorage.getItem("acDataForReset");
  const parsedACDataForReset = JSON.parse(acDataForReset);
  const queryString = window.location.href;
  const urlParams = new URLSearchParams(queryString.replace("#/", ""));
  const paramValue = urlParams.get("type");
  const stateData = useSelector((state) => state.state);
  const headerSlice = useSelector((state) => state.header);
  const stateDataClone = useSelector((state) => state.state.dataClone);
  const yearData = useSelector((state) => state.year);
  const enrollmentFilter = useSelector((state) => state.enrollmentFilter);
  const selectedStateCode = useSelector(
    (state) => state.state.selectedStateCode
  );
  const districtData = useSelector((state) => state.distrct);
  const districtDataClone = useSelector((state) => state.distrct.dataClone);
  const blockData = useSelector((state) => state.block);
  const blockDataClone = useSelector((state) => state.block.dataClone);
  const headerData = useSelector((state) => state.header);
  const [isStateSelected, setIsStateSelected] = useState(false);
  const [selectedState, setSelectedState] = useState(nationalWiseName);
  const [selectedStateW, setSelectedStateW] = useState("State Wise");
  const [selectedDistrict, setSelectedDistrict] = useState(district);
  const [selectedDistrictclone, setSelectedDistrictClone] = useState(district);
  const [selectedYear, setSelectedYear] = useState(selectedDYear);
  const [selectedBlock, setSelectedBlock] = useState(block);
  const [selectedBlockClone, setSelectedBlockClone] = useState(block);
  const [isDashbtnDisabled, setIsDashbtnDisabled] = useState(true);
  const [isResetbtnDisabled, setIsResetbtnDisabled] = useState(true);
  const show = useSelector((state) => state.header.show);
  const distBlockWiseData = useSelector((state) => state.distBlockWise);
  let filterObj = structuredClone(enrollmentFilter);
  const [updateYearId, setUpdateYearId] = useState(filterObj.yearId);

  //window.localStorage.setItem("state", selectedState);

  useEffect(() => {
    window.localStorage.setItem("state_wise", selectedStateW);
    window.localStorage.setItem("district", selectedDistrict);
    window.localStorage.setItem("block", selectedBlock);
    window.localStorage.setItem("year", parsedACData?.yearDesc);
  }, [
    selectedState,
    blockData,
    stateData,
    districtData,
    parsedACData?.yearDesc,
  ]);
  const mapStateValue = localStorage.getItem("map_state_name");
  const mapDisValue = window.localStorage.getItem("map_district_name");
  const mapBlockValue = window.localStorage.getItem("block");
  const mapYearValue = window.localStorage.getItem("year");
  useEffect(() => {
    dispatch(fetchYearData()).then((res) => {
      dispatch(fetchStateData(res.payload.data[0].yearId));
      const children = document.getElementsByClassName("position-static");
      let filter_drodown = document.getElementsByClassName("filter_drodown")[0];
      if (children.length === 2) {
        filter_drodown?.classList?.add("small-filter-box");
      } else {
        filter_drodown?.classList?.remove("small-filter-box");
      }

      dispatch(allFilter(initialFilterEnrolmet4014Data));
      const handleEvent = () => {
        // setShow(false);
        dispatch(handleShowFilter(false));
      };
      const targetElement = window.document.getElementById("content");
      targetElement?.removeEventListener("click", handleEvent);
      targetElement?.addEventListener("click", function (e) {
        handleEvent();
      });

      return () => {
        targetElement.removeEventListener("click", handleEvent);
      };
    });
  }, []);

  useEffect(() => {
    filterObj = structuredClone(enrollmentFilter);
    // filterObj={...filterObj,yearId:headerSlice.selectYearId}
  }, [enrollmentFilter]);

  const resetFilter = (yearId, yearReport, initialFilterEnrolmet4014Data) => {
    const obj = {
      yearId: parsedACDataForReset.yearId,
      yearDesc: parsedACDataForReset.yearDesc,
    };


    localStorage.setItem("acData", JSON.stringify(obj));
    dispatch(removeAllDistrict());
    dispatch(removeAllBlock());
    setSelectedYear(yearReport);
    dispatch(setSelectYearId(yearId));
    setSelectedBlock(block);
    setIsStateSelected(false);
    dispatch(handleRegionName("States"));
    if (headerData.activeTab === "table") {
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", parsedACDataForReset?.yearDesc);
      initialFilterEnrolmet4014Data.yearId = parsedACDataForReset?.yearId;
      handleAPICallAccordingToFilter(initialFilterEnrolmet4014Data);
      dispatch(allFilter(initialFilterEnrolmet4014Data));
    }
    // else if (headerData.activeTab === "graph") {

    //   window.localStorage.setItem("state", "State Wise");
    //   window.localStorage.setItem("map_state_name", "State Wise");
    //   window.localStorage.setItem("map_district_name", "District");
    //   window.localStorage.setItem("district", "District");
    //   window.localStorage.setItem("block", "Block");
    //   handleAPICallAccordingToFilter(initialFilterEnrolmet4014Data);
    //   dispatch(allFilter(initialFilterEnrolmet4014Data));

    // }

    dispatch(handleCurrentIndex(0));
  };
  const handleSchoolFilterYear = (e) => {
    console.log('filterObj', filterObj)
    const splittedArr = e.split("@");
    const year = parseInt(splittedArr[0]);
    const year_report = splittedArr[1];
    const obj = {
      yearId: year,
      yearDesc: year_report,
    };
    localStorage.setItem("acData", JSON.stringify(obj));
    setSelectedYear(year_report);
    dispatch(setSelectYearId(year));
    filterObj.yearId = year;

    dispatch(allFilter(filterObj));
    setUpdateYearId(filterObj?.yearId);
    const initialRateDate = {
      ...filterObj,
      yearId: year,
    };

    handleAPICallAccordingToFilter(initialRateDate);
    window.localStorage.setItem("year", year_report);
    window.localStorage.setItem("selectedYearId", year);
    hideOpendFilterBox();
  };

  const handleSchoolFilterState = (e) => {
    const splittedArr = e.split("@");
    const state_code = splittedArr[0];
    const state_name = splittedArr[1];

    console.log('filterObj', filterObj)
    filterObj.yearId = updateYearId;

    setIsStateSelected(true);
    setSelectedState(state_name);
    setSelectedStateW(state_name);
    setSelectedDistrict(district);
    setSelectedBlock(block);
    setSelectedBlockClone(block);

    window.localStorage.setItem("map_state_name", state_name);

    //
    dispatch(updateUdiseDistrictCode(state_code));
    dispatch(handleRegionName("States"));
    dispatch(setSelectedStateCode(state_code));

    /*--------------------Filter by National----------------------*/
    if (state_name === nationalWiseName) {
      sessionStorage.setItem("handle", "");
      filterObj.regionType = nWiseregionType;
      filterObj.regionCode = nWiseregionCode;
      filterObj.dashboardRegionType = 10;
      filterObj.dashboardRegionCode = "09";
      filterObj.dType = 10;
      filterObj.dCode = 99;
      // const updatedFilterObj = {
      //   regionType: nWiseregionType,
      //   regionCode: nWiseregionCode,
      //   dashboardRegionType: 10,
      //   dashboardRegionCode: "09",
      //   dType: 10,
      //   dCode: 99,
      //   valueType: selectedStateCode.valueType,
      //   yearId: parsedACData?.yearId,
      // };
      // dispatch(setReserveUpdatedFilter(updatedFilterObj));
      dispatch(allFilter(filterObj));
      handleAPICallAccordingToFilter(filterObj);
      const elements = document.querySelectorAll(".impact-box-content.active");
      elements.forEach((element) => {
        element.classList.remove("active");
      });

      dispatch(handleShowDistrict(false));
      dispatch(removeAllDistrict());
      dispatch(removeAllBlock());
      setSelectedDistrictClone(district);
    } else if (state_name === stateWiseName) {
      /*--------------------Filter by State Wise----------------------*/

      filterObj.regionType = allSWiseregionType;
      filterObj.regionCode = allSWiseregionCode;

      filterObj.dType = allSWiseregionType;
      filterObj.dCode = allSWiseregionCode;

      filterObj.dashboardRegionType = 11;
      filterObj.dashboardRegionCode = state_code;
      const updatedFilterObj = {
        regionType: allSWiseregionType,
        regionCode: allSWiseregionCode,
        dType: allSWiseregionType,
        dCode: allSWiseregionCode,
        dashboardRegionType: 11,
        dashboardRegionCode: state_code,
        valueType: location.pathname !== "/" ? 1 : 2,
        categoryCode: 0,
        schoolTypeCode: 0,
        locationCode: 0,
        managementCode: 0,
        yearId: parsedACData?.yearId,
      };

      // dispatch(setReserveUpdatedFilter(updatedFilterObj));
      dispatch(allFilter(filterObj));

      handleAPICallAccordingToFilter(filterObj);

      dispatch(removeAllDistrict());
      dispatch(removeAllBlock());
      setSelectedDistrictClone(district);
    } else {
      /*--------------------Filter by Particular State ----------------------*/
      filterObj.regionType = specificSWiseregionType;
      filterObj.regionCode = state_code;

      filterObj.dType = 11;
      filterObj.dCode = state_code;

      filterObj.dashboardRegionType = 11;
      filterObj.dashboardRegionCode = state_code;
      const updatedFilterObj = {
        regionType: specificSWiseregionType,
        regionCode: state_code,
        dType: 11,
        dCode: state_code,
        dashboardRegionType: 11,
        dashboardRegionCode: state_code,
        valueType: location.pathname !== "/" ? 1 : 2,
        categoryCode: 0,
        schoolTypeCode: 0,
        locationCode: 0,
        managementCode: 0,
        yearId: parsedACData?.yearId,
      };

      //  dispatch(setReserveUpdatedFilter(updatedFilterObj));

      dispatch(allFilter(filterObj));
      if (headerData.isViewDataByShow) {
        handleAPICallAccordingToFilter(filterObj);
      } else if (!headerData.isViewDataByShow && location.pathname !== "/") {
        const district_data = state_code + "@" + districtWiseName;
        handleSchoolFilterDistrict(district_data);
      }
      dispatch(
        fetchDistrictDataByStateCode({
          state_code: state_code,
          yearId: filterObj.yearId,
        })
      );
      dispatch(removeAllDistrict());
      dispatch(removeAllBlock());
      setSelectedDistrictClone(state_name);

      dispatch(handleShowDistrict(true));
    }

    dispatch(updateFilterState(stateDataClone.data));
    window.localStorage.setItem("state", state_name);
    window.localStorage.setItem("map_state_name", state_name);
    window.localStorage.setItem("map_district_name", "District");
    dispatch(handleCurrentIndex(0));
    hideOpendFilterBox();
  };

  const handleSchoolFilterDistrict = (e) => {
    const splittedArr = e.split("@");
    const district_code = splittedArr[0];
    const district_name = splittedArr[1];
    filterObj.yearId = updateYearId;
    dispatch(handleRegionName("Districts"));
    dispatch(updateUdiseBlockCode(district_code));
    if (district_name === districtWiseName) {
      filterObj.regionType = allDWiseregionType;
      filterObj.regionCode = district_code;
      filterObj.dashboardRegionType = 22;
      filterObj.dashboardRegionCode = "09";
      filterObj.dType = allDWiseregionType;
      filterObj.dCode = district_code;
      filterObj.yearId = headerData.selectYearId;

      const updatedFilterObj = {
        regionType: allDWiseregionType,
        regionCode: district_code,
        dashboardRegionType: 22,
        dashboardRegionCode: "09",
        dType: allDWiseregionType,
        dCode: district_code,
        valueType: location.pathname !== "/" ? 1 : 2,
        categoryCode: 0,
        schoolTypeCode: 0,
        locationCode: 0,
        managementCode: 0,
        yearId: parsedACData?.yearId,
      };
      //dispatch(setReserveUpdatedFilter(updatedFilterObj));

      dispatch(allFilter(filterObj));
      handleAPICallAccordingToFilter(filterObj);
      dispatch(removeAllBlock());
      setSelectedBlockClone(block);
      // setSelectedBlock(block_name);
    } else {
      filterObj.regionType = specificDWiseregionType;
      filterObj.regionCode = district_code;
      filterObj.dashboardRegionType = 12;
      filterObj.dashboardRegionCode = district_code;
      filterObj.dType = specificDWiseregionType;
      filterObj.dCode = district_code;
      filterObj.yearId = headerData.selectYearId;

      dispatch(
        fetchBlockByDistrictCode({
          district_code: district_code,
          yearId: filterObj.yearId,
        })
      );
      const updatedFilterObj = {
        regionType: specificDWiseregionType,
        regionCode: district_code,
        dashboardRegionType: 12,
        dashboardRegionCode: district_code,
        dType: specificDWiseregionType,
        dCode: district_code,
        valueType: location.pathname !== "/" ? 1 : 2,
        categoryCode: 0,
        schoolTypeCode: 0,
        locationCode: 0,
        managementCode: 0,
        yearId: parsedACData?.yearId,
      };
      //dispatch(setReserveUpdatedFilter(updatedFilterObj));

      dispatch(allFilter(filterObj));
      setSelectedBlockClone(district_name);
      handleAPICallAccordingToFilter(filterObj);
      /*this function will be called when chart tab selected*/
    }
    dispatch(updateFilterDistrict(districtDataClone.data));
    dispatch(removeAllBlock());
    setSelectedDistrict(district_name);
    setSelectedBlock(block);
    setSelectedBlockClone(block);
    window.localStorage.setItem("map_district_name", district_name);
    window.localStorage.setItem("district", district_name);
    dispatch(handleCurrentIndex(0));

    hideOpendFilterBox();
  };

  const handleSchoolFilterBlock = (e) => {
    const splittedArr = e.split("@");
    const block_code = splittedArr[0];
    const block_name = splittedArr[1];
    filterObj.yearId = updateYearId;
    dispatch(handleRegionName("Blocks"));
    if (block_name === blockWiseName) {
      filterObj.regionType = allBWiseregionType;
      filterObj.regionCode = block_code;
      filterObj.dType = allBWiseregionType;
      filterObj.dCode = block_code;
      filterObj.yearId = headerData.selectYearId;
      const updatedFilterObj = {
        regionType: allBWiseregionType,
        regionCode: block_code,
        dType: allBWiseregionType,
        dCode: block_code,
        categoryCode: 0,
        schoolTypeCode: 0,
        locationCode: 0,
        managementCode: 0,
        yearId: parsedACData?.yearId,
      };
      // dispatch(setReserveUpdatedFilter(updatedFilterObj));
      dispatch(allFilter(filterObj));
    } else {
      filterObj.regionType = specificBWiseregionType;
      filterObj.regionCode = block_code;
      filterObj.dType = specificBWiseregionType;
      filterObj.dCode = block_code;
      filterObj.yearId = headerData.selectYearId;
      const updatedFilterObj = {
        regionType: specificBWiseregionType,
        regionCode: block_code,
        dType: specificBWiseregionType,
        dCode: block_code,
        categoryCode: 0,
        schoolTypeCode: 0,
        locationCode: 0,
        managementCode: 0,
        yearId: parsedACData?.yearId,
      };
      // dispatch(setReserveUpdatedFilter(updatedFilterObj));

      dispatch(allFilter(filterObj));
      handleAPICallAccordingToFilter(filterObj);
    }
    dispatch(updateFilterBlock(blockDataClone.data));
    setSelectedBlock(block_name);
    setSelectedBlock(block);
    setSelectedBlockClone(block);
    window.localStorage.setItem("block", block_name);
    dispatch(handleCurrentIndex(0));

    hideOpendFilterBox();
  };

  /*----------Call API According to Filter-----------*/
  const handleAPICallAccordingToFilter = (obj) => {
    if (location.pathname === "/student-reports-4014") {
        obj.itemId=0;
        console.log('obj----->', obj)
      dispatch(fetchArchiveServicesEnrolmentRelatedIndicators(obj));
    }
  };

  /*-------------------end here----------------------*/

  /*------------Dropdown List----------------*/

  const districtDropdownOptions = () => {
    let extra_col;
    if (districtData.data && districtData.data.data) {
      extra_col = JSON.parse(JSON.stringify(districtData?.data?.data));
    } else {
      extra_col = [];
    }
    if (selectedDistrictclone !== district) {
      extra_col.unshift({
        udiseDistrictCode: distBlockWiseData.districtUdiseCode,
        udiseDistrictName: "District Wise",
      });
    }
    // hide District Wise option from filter dropdown
    if (
      (location.pathname === "/school-reports-1005" ||
        location.pathname === "/school-reports-1003" ||
        location.pathname === "/infrastructure-reports3013" ||
        location.pathname === "/teacher-reports-2008") &&
      headerData.activeTab === "graph"
    ) {
      if (selectedDistrictclone !== district) {
        extra_col.shift({
          udiseDistrictCode: distBlockWiseData.districtUdiseCode,
          udiseDistrictName: "District Wise",
        });
      }
    }
    if (location.pathname === "/") {
      if (selectedDistrictclone !== district) {
        extra_col.shift({
          udiseDistrictCode: distBlockWiseData.districtUdiseCode,
          udiseDistrictName: "District Wise",
        });
      }
    }
    return extra_col;
  };
  const blockDropdownOptions = () => {
    let extra_col;
    if (blockData.data && blockData.data.data) {
      extra_col = JSON.parse(JSON.stringify(blockData.data.data));
    } else {
      extra_col = [];
    }
    if (selectedBlockClone === block) {
      extra_col.unshift({
        udiseBlockCode: distBlockWiseData.blockUdiseCode,
        udiseBlockName: "Block Wise",
      });
    }
    // hide Block Wise option from filter dropdown
    if (
      (location.pathname === "/school-reports-1005" ||
        location.pathname === "/school-reports-1003" ||
        location.pathname === "/infrastructure-reports3013" ||
        location.pathname === "/teacher-reports-2008") &&
      headerData.activeTab === "graph"
    ) {
      if (selectedBlockClone === block) {
        extra_col.shift({
          udiseBlockCode: distBlockWiseData.blockUdiseCode,
          udiseBlockName: "Block Wise",
        });
      }
    }
    if (location.pathname === "/") {
      if (selectedBlockClone !== block) {
        extra_col.shift({
          udiseBlockCode: distBlockWiseData.blockUdiseCode,
          udiseBlockName: "Block Wise",
        });
      }
    }
    return extra_col;
  };
  /*-------------End Here----------------*/
  const hideOpendFilterBox = () => {
    const boxes = document.querySelectorAll(".dropdown-menu");
    boxes.forEach((box) => {
      box.classList.remove("show");
    });
  };
  // const [show, setShow] = useState(false);

  const stateDropdownOptions = () => {
    let extra_col = [];

    if (stateData?.data && stateData?.data?.data) {
      extra_col = JSON.parse(JSON.stringify(stateData?.data?.data));
    }

    extra_col.unshift({
      udiseStateCode: allSWiseregionType.toString(),
      udiseStateName: stateWiseName,
    });

    // hide State Wise option from filter dropdown
    if (
      (location.pathname === "/school-reports-1005" ||
        location.pathname === "/school-reports-1003" ||
        location.pathname === "/teacher-reports-2008") &&
      headerData.activeTab === "graph"
    ) {
      extra_col.shift({
        udiseStateCode: allSWiseregionType.toString(),
        udiseStateName: stateWiseName,
      });
    }
    if (location.pathname === "/") {
      extra_col.shift({
        udiseStateCode: allSWiseregionType.toString(),
        udiseStateName: stateWiseName,
      });
    }
    extra_col.unshift({
      udiseStateCode: nWiseregionType.toString(),
      udiseStateName: nationalWiseName,
    });
    return extra_col;
  };

  const handleResetBtn = () => {
    const initialFilterEnrollmet4014Datas = initialFilterEnrolmet4014Data;
    resetFilter(
      parsedACDataForReset?.yearId,
      parsedACDataForReset?.yearDesc,
      initialFilterEnrollmet4014Datas
    );
  };

  useEffect(() => {
    setSelectedState(selectedState);
  }, [selectedState]);

  useEffect(() => {
    if (
      mapStateValue === "All India/National" &&
      parsedACDataForReset?.yearDesc === parsedACData?.yearDesc
    ) {
      setIsResetbtnDisabled(true);
    } else {
      setIsResetbtnDisabled(false);
    }
  }, [
    mapStateValue,
    selectedYear,
    parsedACData?.yearDesc,
    parsedACDataForReset?.yearDesc,
  ]);

  return (
    <>
      <div
        className="Side_filter"
        onClick={() => dispatch(handleShowFilter(!show))}
      >
        <div className="open-btn">
          {!show ? (
            <span className="material-icons-round">sort</span>
          ) : (
            <span className="material-icons-round">expand_more</span>
          )}
        </div>
      </div>
      <div
        className={`custmize-filter-column ${show ? "show" : ""}`}
        id="customize_filter"
      >
        <div className="search-f-box">
          <div className="heading-sm main-title d-flex align-items-center">
            <span className="material-icons-round text-blue me-3">sort</span>{" "}
            Apply Filters
          </div>
          <div className="box-cont-cust">
            <div className="search-box-div mb-3">
              <span className="select-lable-title">Select Year</span>
              <Select
                mode="single"
                showSearch={true}
                id="year-id"
                placeholder={parsedACData?.yearDesc}
                value={parsedACData?.yearDesc}
                onChange={handleSchoolFilterYear}
                style={{
                  width: "100%",
                }}
                options={yearData?.data?.data.map((item) => ({
                  value: item.yearId + "@" + item.yearDesc,
                  label: item.yearDesc,
                }))}
              />
            </div>
            <div className="search-box-div mb-3">
              <span className="select-lable-title">Select State</span>
              <Select
                mode="single"
                showSearch={true}
                placeholder={selectedState || "Select a state"}
                value={mapStateValue}
                onChange={handleSchoolFilterState}
                id="school_state"
                name="map_state_name"
                style={{
                  width: "100%",
                }}
                options={stateDropdownOptions().map((item) => ({
                  value:
                    item.udiseStateCode +
                    "@" +
                    item.udiseStateName +
                    "@" +
                    item.longitude +
                    "@" +
                    item.latitude,
                  label: item.udiseStateName,
                }))}
              />
            </div>
            {/* <div className="search-box-div mb-3">
              <span className="select-lable-title">Select District</span>
              <Select
                mode="single"
                showSearch={true}
                placeholder={selectedDistrict || "Select a district"}
                value={mapDisValue}
                onChange={handleSchoolFilterDistrict}
                name="map_district_name"
                style={{
                  width: "100%",
                }}
                options={districtDropdownOptions().map((item) => ({
                  value: item.udiseDistrictCode + "@" + item.udiseDistrictName,
                  label: item.udiseDistrictName,
                }))}
                disabled={!isStateSelected}
              />
            </div> */}

            {/* {location.pathname !== "/" && (
              <div className="search-box-div">
                <span className="select-lable-title">Select Block</span>
                <Select
                  mode="single"
                  showSearch={true}
                  placeholder={selectedBlock}
                  value={mapBlockValue}
                  onChange={handleSchoolFilterBlock}
                  name="block"
                  style={{
                    width: "100%",
                  }}
                  options={blockDropdownOptions().map((item) => ({
                    value: item.udiseBlockCode + "@" + item.udiseBlockName,
                    label: item.udiseBlockName,
                  }))}
                />
              </div>
            )} */}
            <div className="text-center mt-2">
              <button
                className="btn btn-primary btn-reset-filter"
                disabled={isResetbtnDisabled}
                onClick={handleResetBtn}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
